import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp: number; // Expiry timestamp in seconds
  [key: string]: any;
}

export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Invalid token', error);
    return true; // Treat invalid tokens as expired
  }
}
